import { CircularProgress } from "@mui/material";
import React, { memo, useState } from "react";
import { useTranslation } from "react-i18next";
import type { CoordinateType, Vectors } from "../../../../services/api/instances/embeddingsApi/types";
import { AppChart } from "../../../../shared/components/AppChart";
import { MainToggleButton } from "./MainToggleButton";
import styles from "./styles.module.css";

interface Props {
	vectors: Vectors | null;
	isLoading: boolean;
}

export const Main: React.FC<Props> = memo(({ vectors, isLoading }) => {
  const { t } = useTranslation();
  const [visibility, setVisibility] = useState<boolean>(false);
  const handleVisibility = (
    event: React.MouseEvent<HTMLElement>,
    newVisibility: boolean | null
  ) => {
    if (newVisibility !== null) {
      setVisibility(newVisibility);
    }
  };

  const cords =
		vectors?.coordinates.map((cord: CoordinateType) => {
		  return {
		    x: cord.x,
		    y: cord.y,
		    label: cord.sentence,
		  };
		}) || [];

  return (
    <div className={styles.main}>
      <div className={styles["top-container"]}>
        <h2 className={styles.title}>{t("embeddings.result")}</h2>
        <MainToggleButton
          visibility={visibility}
          handleVisibility={handleVisibility}
        />
      </div>
      <div className={styles["graph-container"]}>
        {isLoading ? (
          <CircularProgress size={60} color="success"/>
        ) : (
          <AppChart cords={cords} isVisible={visibility}/>
        )}
      </div>
      <div>
        <h3 className={styles["links-title"]}>
          {t("embeddings.educational_material")}
        </h3>
        <div className={styles.links}>
          <a
            target="_blank"
            href="https://habr.com/ru/articles/812431/"
            rel="noreferrer"
          >
            {t("embeddings.about")}
          </a>
        </div>
      </div>
    </div>
  );
});
